import {Injectable, InjectionToken} from "@angular/core";

@Injectable()
export abstract class App {
  appLocale: any;
  Variables: any;
  Actions: any;
  onAppVariablesReady: Function;
  onSessionTimeout: Function;
  onPageReady: Function;
  onBeforePageLeave: Function;
  onBeforeServiceCall: Function;
  onServiceSuccess: Function;
  onServiceError: Function;
  projectName: string;
  isPrefabType: boolean;
  isApplicationType: boolean;
  isTabletApplicationType: boolean;
  isTemplateBundleType: boolean;
  changeLocale: Function;
  getSelectedLocale: Function;
  reload: Function;
  on401: Function;
  notifyApp: Function;
  getDependency: Function;
  networkStatus: any;
  notify: (eventName: string, data?: any) => void;
  deployedUrl: string;
  customUrlScheme: string;
  selectedViewPort: Object;
  subscribe: (eventName: string, callback: (data: any) => void) => () => void;
  dynamicComponentContainerRef: any;
  clearPageCache: (pageName?: string) => void;

  activePageName: string;
  activePage: any;
  Page: any;
  activePageLoadTime: number;
  landingPageName: string;
  lastActivePageName: string;
  deviceCategory: string;
}

@Injectable()
export abstract class AbstractHttpService {
  public abstract send(options: any): any;
  public abstract setLocale(locale: string): any;
  public abstract getLocale(): any;
  public abstract parseErrors(errors: any): any;
  public abstract parseError(errorObj: any): any;
  public abstract getHeader(error: any, headerKey: any): any;
  public abstract isPlatformSessionTimeout(error: any): any;
  public abstract get(url: string, options?: any): any;
  public abstract post(url: string, data: any, options: any): any;
  public abstract put(url: string, data: any, options: any): any;
  public abstract patch(url: string, data: any, options: any): any;
  public abstract delete(url: string, options: any): any;
  public abstract head(url: string, options: any): any;
  public abstract jsonp(url: string, options: any): any;
  public abstract upload(url: string, data: any, options: any): any;
  public abstract registerOnSessionTimeout(callback: any): any;
  public abstract on401(): any;
  public abstract pushToSessionFailureQueue(callback: any): any;
  public abstract executeSessionFailureRequests(): any;
  public abstract sendCallAsObservable(options: any, params?: any): any;
}

@Injectable()
export abstract class UserDefinedExecutionContext {

}

export interface NavigationOptions {
  $event?: any;
  pageName?: string;
  transition?: string;
  urlParams?: any;
  viewName?: string;
}

@Injectable()
export abstract class AbstractNavigationService {
  public abstract getPageTransition(): string | null;
  public abstract goToPage(pageName: string, options: NavigationOptions): any;
  public abstract goToPrevious(): any;
  public abstract goToView(viewName: string, options: NavigationOptions, variable: any): any;
}

@Injectable()
export abstract class DynamicComponentRefProvider {
  public abstract getComponentFactoryRef(selector: string, markup: string, options?: any): any;
  public abstract addComponentBasedOnSelector(target: HTMLElement | null, markup: string, context: any, options: any): any;
}

enum Operation {
  LIST_RECORDS = 'listRecords',
  UPDATE_RECORD = 'updateRecord',
  INSERT_RECORD = 'insertRecord',
  DELETE_RECORD = 'deleteRecord',
  INVOKE = 'invoke',
  UPDATE = 'update',
  NOTIFY = 'notify',
  IS_API_AWARE = 'isApiAware',
  SUPPORTS_CRUD = 'supportsCRUD',
  SUPPORTS_DISTINCT_API = 'supportsDistinctAPI',
  IS_PAGEABLE = 'isPageable',
  IS_SORTABLE = 'isSortable',
  GET_OPERATION_TYPE = 'getOperationType',
  GET_RELATED_PRIMARY_KEYS = 'getRelatedTablePrimaryKeys',
  GET_ENTITY_NAME = 'getEntityName',
  SET_INPUT = 'setinput',
  GET_RELATED_TABLE_DATA = 'getRelatedTableData',
  GET_DISTINCT_DATA_BY_FIELDS = 'getDistinctDataByFields',
  GET_AGGREGATED_DATA = 'getAggregatedData',
  GET_MATCH_MODE = 'getMatchMode',
  DOWNLOAD = 'download',
  GET_NAME = 'getName',
  GET_PROPERTIES_MAP = 'getPropertiesMap',
  GET_PRIMARY_KEY = 'getPrimaryKey',
  GET_BLOB_URL = 'getBlobURL',
  SUPPORTS_SERVER_FILTER = 'supportsServerFilter',
  GET_OPTIONS = 'getOptions',
  SEARCH_RECORDS = 'searchRecords',
  GET_REQUEST_PARAMS = 'getRequestParams',
  GET_PAGING_OPTIONS = 'getPagingOptions',
  FETCH_DISTINCT_VALUES = 'fetchDistinctValues',
  GET_UNIQUE_IDENTIFIER = 'getUniqueIdentifier',
  GET_CONTEXT_IDENTIFIER = 'getContextIdentifier',
  IS_UPDATE_REQUIRED = 'isUpdateRequired',
  ADD_ITEM = 'addItem',
  SET_ITEM = 'setItem',
  REMOVE_ITEM = 'removeItem',
  IS_BOUND_TO_LOCALE = 'isBoundToLocale',
  GET_DEFAULT_LOCALE = 'getDefaultLocale',
  CANCEL = 'cancel',
  SET_PAGINATION = 'setPagination'
}

export const DataSource = {
  Operation
};
